export default __webpack_public_path__ + "static/media/horn_two.083a4537.mp3";